"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedRegistryWidgetContextProvider = exports.EmbedRegistryWidget = void 0;
var react_1 = __importDefault(require("react"));
var EmbedPresetsWidgetContext_1 = require("./EmbedPresetsWidgetContext");
var EmbedRegistryWidgetEmbedWidget_1 = __importDefault(require("./EmbedRegistryWidgetEmbedWidget"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontend/Tokens/Types");
var widgetEventHelperFunctions_1 = require("./widgetEventHelperFunctions");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EnterEmbedCode_1 = __importDefault(require("./EnterEmbedCode"));
var ChooseSource_1 = __importDefault(require("./ChooseSource"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./EmbedRegistryWidget.css"));
var inversify_react_1 = require("inversify-react");
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var Resizer_1 = require("Project/QwilrEditor/RegistryElement/Resizer");
var classnames_1 = __importDefault(require("classnames"));
var EmbedRegistryWidget = function (_a) {
    var element = _a.element, children = _a.children;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var isSelected = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState === "circle";
    var tokensEnableState = (0, inversify_react_1.useInjection)("tokensEnableState");
    return (react_1.default.createElement(EmbedPresetsInternalWidget, { element: element, alignment: "center", widgetManager: widgetManager, telemetry: telemetry, enableTokens: tokensEnableState, variable: element.data.variable, isSelected: isSelected, embedUrl: element.data.embedUrl }, children));
};
exports.EmbedRegistryWidget = EmbedRegistryWidget;
var CloseButton = function (_a) {
    var onClose = _a.onClose;
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onClose, icon: react_1.default.createElement(icons_1.Close, null), className: styles.closeButton, isIconOnly: true, size: kaleidoscope_1.ButtonSize.Small }));
};
var EmbedPresetsInternalWidget = function (_a) {
    var props = __rest(_a, []);
    var instructions = props.enableTokens === Types_1.TokensEnableState.EnabledWithAllInteractions
        ? "Drag a token in, or type a token name above"
        : "Type a token name above";
    var variableDetails = {
        variable: props.variable,
        instructions: instructions,
        icon: icons_1.Api,
    };
    var widgetManager = props.widgetManager, telemetry = props.telemetry, embedUrl = props.embedUrl, element = props.element, isSelected = props.isSelected, children = props.children;
    var triggerWidgetFunc = function (eventData) { return (0, widgetEventHelperFunctions_1.triggerWidgetEvent)(eventData, widgetManager); };
    var resizingContext = (0, Resizer_1.useResizerContext)();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("iframe-widget", styles.iframeWidget) },
        react_1.default.createElement(EmbedPresetsWidgetContext_1.EmbedPresetsWidgetContextConsumer, null, function (_a) {
            var currentStep = _a.currentStep, showPresetsOverlay = _a.showPresetsOverlay, setShowPresetsOverlay = _a.setShowPresetsOverlay, mode = _a.mode;
            return (react_1.default.createElement(EmbedRegistryWidgetEmbedWidget_1.default, { isSelected: isSelected, element: element, telemetry: telemetry, widgetManager: widgetManager, placeholder: currentStep === EmbedPresetsWidgetContext_1.EmbedStep.EnterEmbedCode ? (react_1.default.createElement(EnterEmbedCode_1.default, { embedUrl: embedUrl, closeButton: showPresetsOverlay && react_1.default.createElement(CloseButton, { onClose: function () { return setShowPresetsOverlay(false); } }) })) : (react_1.default.createElement(ChooseSource_1.default, { closeButton: showPresetsOverlay && react_1.default.createElement(CloseButton, { onClose: function () { return setShowPresetsOverlay(false); } }) })), triggerWidgetEvent: triggerWidgetFunc, embedUrl: mode === "url" ? embedUrl : undefined, allowVariables: props.enableTokens !== Types_1.TokensEnableState.Disabled, variableDetails: variableDetails, showPlaceholderAsOverlay: showPresetsOverlay, showPlaceholderInsteadOfTokenDropArea: mode === "url", isResizing: resizingContext.resizingEnabled && resizingContext.isResizing }, children));
        })));
};
var EmbedRegistryWidgetContextProvider = function (_a) {
    var element = _a.element, children = _a.children;
    var embedUrl = element.data.embedUrl;
    var embedPreset = element.data.embedPreset;
    var variable = element.data.variable;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    return (react_1.default.createElement(EmbedPresetsWidgetContext_1.EmbedPresetsWidgetContextProvider, { element: element, embedPreset: embedPreset, telemetry: telemetry, widgetManager: widgetManager, embedUrl: embedUrl, variable: variable }, children));
};
exports.EmbedRegistryWidgetContextProvider = EmbedRegistryWidgetContextProvider;
